import { render, staticRenderFns } from "./DoctorActivity.vue?vue&type=template&id=579ff1cd&scoped=true"
import script from "./DoctorActivity.vue?vue&type=script&lang=js"
export * from "./DoctorActivity.vue?vue&type=script&lang=js"
import style0 from "./DoctorActivity.vue?vue&type=style&index=0&id=579ff1cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579ff1cd",
  null
  
)

export default component.exports